import { useEffect, useState } from 'react';

const CARECUES_UPLOAD_MODAL_DISMISSED_KEY = 'wp:carecues:upload-modal-dismissed';

export function useCareCuesModalDismissStatus(userId: string) {
  const [isModalDismissed, setIsModalDismissed] = useState(false);

  const careCuesUploadModalDismissed = `${CARECUES_UPLOAD_MODAL_DISMISSED_KEY}:${userId}`;

  useEffect(() => {
    const dismissed = localStorage.getItem(careCuesUploadModalDismissed);
    if (dismissed) {
      setIsModalDismissed(dismissed === 'true');
    }
  }, []);

  const setModalDismissed = () => {
    localStorage.setItem(careCuesUploadModalDismissed, 'true');
    setIsModalDismissed(true);
  };

  return {
    isModalDismissed,
    setModalDismissed,
  };
}
